import { render } from "./NavDots.vue?vue&type=template&id=fb34516c"
import script from "./NavDots.vue?vue&type=script&lang=js"
export * from "./NavDots.vue?vue&type=script&lang=js"

import "./NavDots.vue?vue&type=style&index=0&id=fb34516c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__